import React from 'react'
import { RemoveQuestionFlowProvider } from './context/RemoveQuestionFlowProvider'
import { RemoveQuestionFlowMain } from './components/RemoveQuestionFlowMain'

export const RemoveQuestionFlow = () => {
  return (
    <RemoveQuestionFlowProvider>
      <RemoveQuestionFlowMain />
    </RemoveQuestionFlowProvider>
  )
}
